module.exports = __webpack_public_path__ + "static/img/seven.e709a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seven.png
// module id = 1T1U
// module chunks = 1